import { ZimbraClient } from '@zimbra-webif/sdk';

/**
 * Browser SDK client. Talks same-origin to the BFF (`baseUrl: ''`), which
 * injects the auth token server-side. We send the CSRF token (from the session)
 * as a header on every request; the BFF double-submit-checks it.
 */
export function makeClient(csrfToken: string): ZimbraClient {
  return new ZimbraClient({
    baseUrl: '',
    session: true,
    headers: { 'x-zwf-csrf': csrfToken },
  });
}
